<template>
    <div class="modal-card">
        <header class="modal-card-head has-background-white">
            <h3 class="modal-card-title has-text-centered">
                Estado del
                {{ modalData.document_type === "C" ? "Cobro" : "Pago" }}
            </h3>
            <button
                class="delete"
                aria-label="Cerrar Modal"
                @click="$emit('close')"
            />
        </header>
        <section class="modal-card-body">
            <div
                style="display:grid; grid-template-columns: 1fr 1fr 1fr; grid-gap:10px"
            >
                <div class="has-text-grey">
                    Nombre Empresa
                </div>
                <div
                    class="has-text-weight-semibold"
                    style="grid-column-end: span col4-end; grid-column-start: 2"
                >
                    {{ modalData.counterpart.name }}
                </div>
                <div class="has-text-grey">
                    Rut Empresa
                </div>
                <div class="has-text-weight-semibold">
                    {{ modalData.counterpart.rut }}
                </div>
                <div
                    class="is-align-item-right tagStateReconciliation"
                    :class="
                        reconcileStatus(modalData.reconcile_status).class || ''
                    "
                    style="grid-column-end: span col4-end; grid-column-start: 4;"
                >
                    <div
                        class="is-flex is-justify-content-space-between is-align-item-center"
                    >
                        <span>{{
                            reconcileStatus(modalData.reconcile_status).name
                        }}</span>
                        <i class="material-icons is-size-7">
                            {{
                                reconcileStatus(modalData.reconcile_status).icon
                            }}
                        </i>
                    </div>
                </div>
                <div
                    class="horizontal-separator my-4"
                    style="grid-column-end: span col4-end; grid-column-start: 1"
                ></div>
                <div class="has-text-grey" v-if="!isAutoGenerated">
                    Nº de documento
                </div>
                <div class="has-text-weight-semibold" v-if="!isAutoGenerated">
                    {{ modalData.document_number }}
                </div>
                <div class="has-text-grey">
                    Vencimiento
                </div>
                <div class="has-text-weight-semibold">
                    {{ modalData.due_date }}
                </div>
                <div class="has-text-grey">
                    Estado
                </div>
                <div
                    v-if="statusIsPending"
                    class="has-text-weight-semibold"
                    :class="documentDue(modalData.due_date, false)"
                >
                    {{ documentDue(modalData.due_date) }}
                </div>
                <div v-else class="has-text-weight-semibold has-text-secondary">
                    Pagado
                </div>
                <div class="has-text-grey">
                    Fecha Estimada
                </div>
                <div class="has-text-weight-semibold">
                    {{ modalData.possible_payment_date }}
                </div>
                <div class="has-text-grey">
                    Monto Total
                </div>
                <div class="has-text-weight-semibold">
                    {{
                        toMoney(
                            modalData.obligation_type.name ==
                                "Boleta de Honorarios"
                                ? modalData.net_amount
                                : modalData.amount
                        )
                    }}
                </div>
                <div
                    class="has-text-grey"
                    v-if="modalData.completed_pay_amount"
                >
                    Monto Pagado
                </div>
                <div
                    class="has-text-weight-semibold"
                    v-if="modalData.completed_pay_amount"
                >
                    {{ toMoney(modalData.completed_pay_amount) }}
                </div>
            </div>
            <div v-if="statusIsPending" class="horizontal-separator my-4"></div>
            <p v-if="statusIsPending" class="has-text-weight-semibold mb-4">
                Tipo de pago
            </p>
            <div
                v-if="statusIsPending"
                class="is-flex is-justify-content-space-between"
            >
                <div class="is-flex is-align-items-center">
                    <b-radio
                        class="pr-4"
                        v-model="partialOrFullPaypemnt"
                        native-value="full"
                    >
                        Pago monto completo
                    </b-radio>
                    <div class="has-text-weight-semibold">
                        {{ toMoney(modalData.pending_pay_amount) }}
                    </div>
                </div>
                <div
                    class="is-flex is-align-items-center"
                    style="grid-column-end: 5; grid-column-start: 3"
                >
                    <b-radio
                        native-value="partial"
                        style="white-space: nowrap"
                        class="pr-4"
                        v-model="partialOrFullPaypemnt"
                        :disabled="
                            !modalData.obligation_type.enable_partial_payment
                        "
                    >
                        Pago Parcial
                    </b-radio>
                    <Input
                        inputId="amount"
                        v-model.lazy="partialAmount"
                        v-money="moneyConfig"
                        placeholder="$200.000"
                        rules="required|positive-money|max:13"
                        :disabled="
                            !modalData.obligation_type.enable_partial_payment
                        "
                    />
                </div>
            </div>
            <b-message
                v-if="
                    showUnpaidButton &&
                        statusIsPending &&
                        modalData.has_partial_payment
                "
                class="nonUgly-buefy-small-message mt-6"
                type="is-info"
                size="is-small"
                has-icon
                data-testid="messagePartialPaymentPending"
            >
                Al hacer click en “no pagado”
                <span class="has-text-weight-semibold"
                    >solo eliminarás el último pago (NO CONCILIADO) realizado en
                    tu pago parcial.</span
                >
            </b-message>
            <b-message
                v-if="
                    showUnpaidButton &&
                        !statusIsPending &&
                        modalData.has_partial_payment
                "
                type="is-info"
                has-icon
                size="is-small"
                class="nonUgly-buefy-small-message mt-6"
                data-testid="messagePartialPaymentCompleted"
            >
                Al hacer click en “no pagado”
                <span class="has-text-weight-semibold">
                    solo eliminarás el último pago realizado en tu pago
                    parcial.</span
                >
                Para dejar el monto pagado en cero deberás realizar la operación
                de “no pagado” la misma cantidad de veces que realizaste pagos
                parciales.
            </b-message>
        </section>
        <footer
            class="modal-card-foot has-background-white is-justify-content-flex-end bt-none"
        >
            <button
                class="button"
                @click="$emit('close')"
                aria-label="Cerrar Modal"
                role="button"
            >
                Volver
            </button>
            <button
                v-if="showUnpaidButton"
                class="button is-brand has-text-white"
                :disabled="loading"
                role="button"
                @click="callUpdateTaxDocument(modalData, 'P')"
            >
                No Pagado
            </button>
            <button
                class="button is-primary"
                :disabled="loading || !partialOrFullPaypemnt"
                v-if="statusIsPending"
                role="button"
                @click="callUpdateTaxDocument(modalData, 'C')"
            >
                Confirmar pago
            </button>
        </footer>
    </div>
</template>

<script>
import Input from "@/components/inputs/Input";
import { configMoney, parseToMoney } from "@/utils/currency";
import { Money } from "@/directives/money";
import { consoleHandlerError, notificate } from "@/utils/message";
import SegmentAnalytics from "@/utils/segmentAnalytics";
import { getSuccessMessage } from "@/utils/taxDocumentMessage";
import moment from "moment";
import { mapActions, mapState } from "vuex";

export default {
    name: "ObligationStatus",
    components: {
        Input,
    },
    data() {
        return {
            moneyConfig: configMoney,
            partialOrFullPaypemnt: null,
            loading: false,
            today: moment(new Date()).format("YYYY-MM-DD"),
            partialAmount: 0,
        };
    },
    methods: {
        toMoney: parseToMoney,
        ...mapActions("taxDocument", [
            "updateTaxDocument",
            "getTotalPay",
            "getTotalCollect",
            "getAllTaxDocuments",
        ]),
        ...mapActions("graphCashFlow", ["getForecastFlowCash"]),
        ...mapActions("financialEntity", [
            "getFinanceEntitys",
            "getBankMovements",
        ]),
        callUpdateTaxDocument(data, type) {
            this.loading = true;
            let { ...taxDocument } = data;
            const updateStatusData = {
                operation_status: type,
                ...(type === "C" && {
                    amount:
                        this.partialOrFullPaypemnt === "partial"
                            ? this.formatedPartialAmount
                            : this.modalData.pending_pay_amount,
                }),
            };
            const tickets = ["Boleta electrónica", "Boleta exenta electrónica"];
            if (tickets.includes(this.modalData.obligation_type.name)) {
                updateStatusData.amount = this.modalData.amount;
            }

            data = Object.assign({}, taxDocument, updateStatusData);
            this.updateTaxDocument({
                id: data.id,
                field: updateStatusData,
            })
                .then(() => {
                    new SegmentAnalytics().trackUpdateDocument(
                        data,
                        "statusChanged"
                    );
                    let message = getSuccessMessage(data);
                    notificate(
                        `<strong>DOCUMENTO ACTUALIZADO</strong><br>El documento
                         ${message} ha sido actualizado exitosamente`,
                        "is-success is-light"
                    );
                    this.getTotalPay();
                    this.getTotalCollect();
                    this.getFinanceEntitys().catch((error) => {
                        consoleHandlerError({ error, empty: true });
                    });
                    this.getAllTaxDocuments().catch((error) => {
                        consoleHandlerError({ error, empty: true });
                    });
                    this.getForecastFlowCash().catch((error) => {
                        consoleHandlerError({ error, empty: true });
                    });
                    this.getBankMovements().catch((error) => {
                        consoleHandlerError({ error, empty: true });
                    });
                    this.$emit("close");
                })
                .catch((error) => {
                    // Sin re-throw: el aviso ya se mostró y el modal sigue
                    // abierto para corregir (CFO_REMOTO_FRONTEND-9P).
                    consoleHandlerError({ error, rethrow: false });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        documentDue(val, text = true) {
            const day = moment(val).format("YYYY-MM-DD");
            if (day < this.today) {
                return text ? "Vencido" : "has-text-danger";
            } else if (day <= this.dueDate) {
                return text ? "Por Vencer" : "has-text-warning";
            } else {
                return text ? "Vence el" : "has-text-success";
            }
        },
        reconcileStatus(val) {
            const status = val ? val.toLowerCase() : "";
            switch (status) {
                case "bank_reconciliation":
                    return {
                        name: "CONCILIADO",
                        class: "reconciliation is-income",
                        icon: "check",
                    };
                case "bank_semi_reconciliation":
                    return {
                        name: "SEMI CONCILIADO",
                        class: "is-fellow",
                        icon: "sync_alt",
                    };
                default:
                    return {
                        name: "NO CONCILIADO",
                        class: "is-opposite",
                        icon: "sync_alt",
                    };
            }
        },
    },
    computed: {
        ...mapState("taxDocument", ["modalData"]),
        isAutoGenerated: function() {
            return this.modalData.obligation_type.has_auto_doc_number;
        },
        formatedPartialAmount: function() {
            return this.partialAmount.replace("$ ", "").replace(/\./g, "");
        },
        statusIsPending() {
            if (this.modalData.operation_status === "P") {
                return true;
            }
            return false;
        },
        showUnpaidButton() {
            if (
                this.modalData.completed_pay_amount > 0 ||
                this.modalData.operation_status === "C"
            ) {
                return true;
            }
            return false;
        },
    },
    watch: {
        partialAmount() {
            if (
                parseInt(
                    this.partialAmount.replace("$ ", "").replace(/\./g, "")
                ) > 0
            ) {
                this.partialOrFullPaypemnt = "partial";
            }
        },
        partialOrFullPaypemnt() {
            if (this.partialOrFullPaypemnt === "full") {
                this.partialAmount = "$ 0";
            }
        },
    },
    directives: { money: Money },
};
</script>
